import Api from '../utilities/api';
import {
  triggerIdA, triggerIdU
} from './apiConfig';
import TriskeleScreens from './TriskeleScreens';

export default class ProfileAccess {
    static getClientHeader = clientId => Api.post('_Profile_ClientHeader', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.profileHeader.ScreenId

        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'ClientID',
          value: clientId
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    })

    static getClientProfile = clientId => Api.post('_Profile_ClientProfile', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.profileHeader.ScreenId

        },
        {
          name: 'TrggrId',
          value: triggerIdA
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'ClientID',
          value: clientId
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    });

    static getProviderProfile = (providerId, clientId) => Api.post('_Profile_ProviderProfile', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.profileHeader.ScreenId

        },
        {
          name: 'TrggrId',
          value: triggerIdU
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'ClientID',
          value: clientId ? clientId : 1
        },
        {
          name: 'ProviderId',
          value: providerId
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    });

    static getUserProfile = () => Api.post('_Profile_UserProfile', {
      params: [
        {
          name: 'ScrnId',
          value: TriskeleScreens.dashboard.ScreenId

        },
        {
          name: 'TrggrId',
          value: triggerIdU
        },
        {
          name: 'BuildfireID',
          value: "D"
        },
        {
          name: 'isVisible',
          value: 1
        }
      ]
    })
}
